var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('Loader',{attrs:{"fullsize":""}}):_vm._e(),_vm._v(" "),_c('ClientOnly',[_c('Sale')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }